import React, {useState} from 'react';
import {Modal, ModalBody} from "react-bootstrap";


export function Video(props) {


    return (
        <div className={""} key={props.video.url} style={{minWidth:"100%", width:"100%"}} >
            <video
                   loop={true}
                   preload={true}
                   className={" rounded border"}
                   style={{width:"100%"}}
                   controls={true}
                   muted >
                <source src={props.video.url} type="video/mp4"/>
                Nettleseren din støtter ikke filtypen
            </video>
        </div>
    );


}